/* tslint:disabled */
/* eslint-disable */
/**
 * Correlated sources
 * The service provides RESTful API for manipulating correlated sources (CRUD)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ResponseBody } from 'redux-query'
import {
  CorrelatedSource,
  CorrelatedSourceCreatePayload,
  CorrelatedSourceCreatePayloadToJSON,
  CorrelatedSourceFromJSON
} from '../models'
import * as runtime from '../runtime'

export interface SourceCreateRequest {
  correlatedSourceCreatePayload?: CorrelatedSourceCreatePayload
}

export interface SourceDeleteRequest {
  id: string
}

/**
 * Returns list of correlated sources
 * Retrieve list of correlated sources
 */
function getCorrelatedSourcesQueryConfigRaw<T>(
  requestConfig: runtime.TypedQueryConfig<T, Array<CorrelatedSource>> = {}
): runtime.RequestConfig<T> {
  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v1/correlated-sources`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'GET',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(body.map(CorrelatedSourceFromJSON), text)
  }

  return config
}

/**
 * Returns list of correlated sources
 * Retrieve list of correlated sources
 */
export function getCorrelatedSourcesQueryConfig<T>(
  requestConfig?: runtime.TypedQueryConfig<T, Array<CorrelatedSource>>
): runtime.RequestConfig<T> {
  return getCorrelatedSourcesQueryConfigRaw(requestConfig)
}

/**
 * Creates a new correlated source
 * Create a new correlated source
 */
function sourceCreateQueryConfigRaw<T>(
  requestParameters: SourceCreateRequest,
  requestConfig: runtime.TypedQueryConfig<T, CorrelatedSource> = {}
): runtime.RequestConfig<T> {
  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  headerParameters['Content-Type'] = 'application/json'

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v1/correlated-sources`,
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'POST',
      headers: headerParameters
    },
    body:
      queryParameters ||
      CorrelatedSourceCreatePayloadToJSON(
        requestParameters.correlatedSourceCreatePayload
      )
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
    config.transform = (body: ResponseBody, text: ResponseBody) =>
      requestTransform(CorrelatedSourceFromJSON(body), text)
  }

  return config
}

/**
 * Creates a new correlated source
 * Create a new correlated source
 */
export function sourceCreateQueryConfig<T>(
  requestParameters: SourceCreateRequest,
  requestConfig?: runtime.TypedQueryConfig<T, CorrelatedSource>
): runtime.RequestConfig<T> {
  return sourceCreateQueryConfigRaw(requestParameters, requestConfig)
}

/**
 * Deletes correlated source
 * Delete correlated source
 */
function sourceDeleteQueryConfigRaw<T>(
  requestParameters: SourceDeleteRequest,
  requestConfig: runtime.TypedQueryConfig<T, void> = {}
): runtime.RequestConfig<T> {
  if (requestParameters.id === null || requestParameters.id === undefined) {
    throw new runtime.RequiredError(
      'id',
      'Required parameter requestParameters.id was null or undefined when calling sourceDeleteQueryConfig.'
    )
  }

  let queryParameters = null

  const headerParameters: runtime.HTTPHeaders = {}

  const { meta = {} } = requestConfig

  const config: runtime.RequestConfig<T> = {
    url: `${requestConfig.basePath ?? ''}/v1/correlated-sources/{id}`.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters.id))
    ),
    meta,
    update: requestConfig.update,
    queryKey: requestConfig.queryKey,
    optimisticUpdate: requestConfig.optimisticUpdate,
    force: requestConfig.force,
    rollback: requestConfig.rollback,
    options: {
      method: 'DELETE',
      headers: headerParameters
    },
    body: queryParameters
  }

  const { transform: requestTransform } = requestConfig
  if (requestTransform) {
  }

  return config
}

/**
 * Deletes correlated source
 * Delete correlated source
 */
export function sourceDeleteQueryConfig<T>(
  requestParameters: SourceDeleteRequest,
  requestConfig?: runtime.TypedQueryConfig<T, void>
): runtime.RequestConfig<T> {
  return sourceDeleteQueryConfigRaw(requestParameters, requestConfig)
}

//Requests

/**
 * Returns list of correlated sources
 * Retrieve list of correlated sources
 */

async function getCorrelatedSourcesRequestRaw(): Promise<
  runtime.APIResponse<Array<CorrelatedSource>>
> {
  const { url, options, body } = getCorrelatedSourcesQueryConfigRaw()
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    jsonValue.map(CorrelatedSourceFromJSON)
  )
}

/**
 * Returns list of correlated sources
 * Retrieve list of correlated sources
 */
export async function getCorrelatedSources(): Promise<
  runtime.APIResponse<Array<CorrelatedSource>>
> {
  return await getCorrelatedSourcesRequestRaw()
}

/**
 * Creates a new correlated source
 * Create a new correlated source
 */

async function sourceCreateRequestRaw(
  requestParameters: SourceCreateRequest
): Promise<runtime.APIResponse<CorrelatedSource>> {
  const { url, options, body } = sourceCreateQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.JSONApiResponse(response, jsonValue =>
    CorrelatedSourceFromJSON(jsonValue)
  )
}

/**
 * Creates a new correlated source
 * Create a new correlated source
 */
export async function sourceCreate(
  requestParameters: SourceCreateRequest
): Promise<runtime.APIResponse<CorrelatedSource>> {
  return await sourceCreateRequestRaw(requestParameters)
}

/**
 * Deletes correlated source
 * Delete correlated source
 */

async function sourceDeleteRequestRaw(
  requestParameters: SourceDeleteRequest
): Promise<runtime.APIResponse<void>> {
  const { url, options, body } = sourceDeleteQueryConfigRaw(requestParameters)
  const response: Response = await runtime.makeRequestWrapper({
    body,
    options,
    url
  })

  return runtime.VoidApiResponse(response)
}

/**
 * Deletes correlated source
 * Delete correlated source
 */
export async function sourceDelete(
  requestParameters: SourceDeleteRequest
): Promise<runtime.APIResponse<void>> {
  return await sourceDeleteRequestRaw(requestParameters)
}
